import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Initialize Meta Pixel
function initMetaPixel() {
  // Meta Pixel Code
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    // Insert before first script tag if it exists, otherwise append to head
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      b.head.appendChild(t);
    }
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', '889082626778270');
  window.fbq('track', 'PageView');
  // Add noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=889082626778270&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.body.appendChild(noscript);
}
function Root() {
  useEffect(() => {
    // Initialize pixel after component mounts (DOM is ready)
    initMetaPixel();
  }, []);
  return <App data-id="element-590" />;
}
render(<Root data-id="element-591" />, document.getElementById('root'));